module.exports = __webpack_public_path__ + "static/media/icons-lasso-tool.87ae392e.svg";